module.exports = __webpack_public_path__ + "static/media/childhood.30e6d1f7.png";